import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './OfferGalleryContainer.css';
import { TMessage, TOutcomingStatus } from '../../types/messages';
import { OfferMessageContainer } from '../OfferMessageContainer';

type TOfferGalleryContainerProps = {
  isOutcoming: boolean;
  isMessageFailed: boolean;
  messageId: string;
  message: TMessage & { status: TOutcomingStatus };
  formattedText: React.ReactNode | null;
};

export const OfferGalleryContainer: React.FC<TOfferGalleryContainerProps> = ({
  isOutcoming,
  isMessageFailed,
  messageId,
  message,
  formattedText,
}) => {
  const galleryRef = React.useRef<HTMLDivElement | null>(null);
  const [scrollStyles, setScrollStyles] = React.useState({
    hideLeft: true,
    hideRight: false,
  });

  React.useEffect(() => {
    const gallery = galleryRef.current;
    if (!gallery) {
      return;
    }

    const updateArrows = () => {
      setScrollStyles({
        hideLeft: gallery.scrollLeft === 0,
        hideRight: Math.ceil(gallery.scrollLeft + gallery.clientWidth) >= gallery.scrollWidth,
      });
    };

    updateArrows();
    gallery.addEventListener('scroll', updateArrows);

    return () => {
      gallery.removeEventListener('scroll', updateArrows);
    };
  }, []);

  const scrollGallery = (direction: 'left' | 'right') => {
    if (galleryRef.current) {
      const scrollAmount = 300; // Количество пикселей для прокрутки
      galleryRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className={classNames(styles['container'])}>
      <div
        className={classNames(
          styles['round-button-left'],
          scrollStyles.hideLeft && styles['hidden'],
          message.animation && styles['button-animation'],
        )}
        data-testid="left-arrow"
      >
        <RoundButton size="M" title="" icon={<IconActionChevronLeft16 />} onClick={() => scrollGallery('left')} />
      </div>
      <div className={classNames(styles['gallery-container'])} ref={galleryRef}>
        <div className={classNames(styles['gallery'], message.animation && styles['container-animation'])}>
          {message.offers?.map((offer, index) => (
            <div
              className={classNames(styles['bubble'], !message.isRead && classNames(styles['unread-bubble']))}
              key={index}
            >
              <OfferMessageContainer
                key={index}
                isMessageFailed={isMessageFailed}
                messageId={messageId}
                message={{ ...message, offers: [offer] }}
                isOutcoming={isOutcoming}
                textNode={formattedText}
              />
            </div>
          ))}
        </div>
      </div>
      <div
        className={classNames(styles['round-button-right'], scrollStyles.hideRight && styles['hidden'])}
        data-testid="right-arrow"
      >
        <RoundButton size="M" title="" icon={<IconActionChevronRight16 />} onClick={() => scrollGallery('right')} />
      </div>
    </div>
  );
};
